// extracted by mini-css-extract-plugin
export default {"mainFooter":"footer_mainFooter__acNcw","toTop":"footer_toTop__NuKhg","links":"footer_links__HPCUY","socials":"footer_socials__N2YMb","duck":"footer_duck__dEvqc"};